import { request } from '@langlois/request';

export async function revokeInvitation ({ commit }, invitationId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/invitation/${invitationId}`);

		const response = await request.delete(url);

		if (!response.ok) return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while revoking the invitation.`,
			type: `warning`
		}, { root: true });

		commit(`deleteInvitation`, invitationId);

		commit(`vcl/notificationBar/show`, {
			text: `Invitation has been successfully revoked.`,
			type: `success`
		}, { root: true });
	} catch (error) {
		commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while revoking the invitation.`,
			type: `warning`
		}, { root: true });
	}
}
